export const SEMRUSH_ICON_URL = 'https://static.rfstat.com/renderforest/images/website_maker_images/semrush_arrow.svg'